import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { RegionProvider } from "@/context/RegionContext";
import { locumTheme } from "@/theme";
import App from "./App";
import "./fonts.css";

gsap.registerPlugin(ScrollTrigger);

if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
  gsap.globalTimeline.timeScale(0);
  ScrollTrigger.normalizeScroll(false);
}

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element #root not found");

createRoot(rootElement).render(
  <StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={locumTheme}>
        <CssBaseline />
        <RegionProvider>
          <App />
        </RegionProvider>
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>,
);
